module.exports = __webpack_public_path__ + "img/order.2abfa167.svg";